var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSavedAgents = function SvgSavedAgents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 160,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saved_agents_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#saved_agents_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#saved_agents_svg__c)",
    d: "M63.75 144h61.75a13 13 0 0 0 13-13v-6.5a13 13 0 0 0-13-13H63.75V144Zm0-42.25h61.75a13 13 0 0 0 13-13v-6.5a13 13 0 0 0-13-13H63.75v32.5ZM54 69.25v32.5H34.5a13.002 13.002 0 0 1-13-13v-6.5a13 13 0 0 1 13-13H54Zm9.75-9.75h61.75a12.999 12.999 0 0 0 13-13V40a13 13 0 0 0-13-13H63.75v32.5Zm-9.75 52V144H34.5a13 13 0 0 1-13-13v-6.5a12.999 12.999 0 0 1 13-13H54Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#saved_agents_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#saved_agents_svg__e)",
    d: "M28.444 14.965c1.594-4.187 7.518-4.187 9.112 0l2.462 6.465a12.188 12.188 0 0 0 7.052 7.052l6.465 2.462c4.187 1.595 4.187 7.518 0 9.112l-6.465 2.462a12.188 12.188 0 0 0-7.052 7.052l-2.462 6.465c-1.594 4.187-7.518 4.187-9.112 0l-2.462-6.465a12.187 12.187 0 0 0-7.052-7.052l-6.465-2.462c-4.187-1.594-4.187-7.517 0-9.112l6.465-2.462a12.188 12.188 0 0 0 7.052-7.052l2.462-6.465Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#saved_agents_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#saved_agents_svg__g)",
    d: "M130.5 154c9.665 0 17.5-7.835 17.5-17.5s-7.835-17.5-17.5-17.5-17.5 7.835-17.5 17.5 7.835 17.5 17.5 17.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.641,
    d: "M130.5 133.219v-3.281h-3.281m-4.922 8.203h1.641m13.124 0h1.641m-5.742-.821v1.641m-4.922-1.641v1.641m-2.461-5.742h9.844c.906 0 1.64.734 1.64 1.64v6.563a1.64 1.64 0 0 1-1.64 1.64h-9.844a1.64 1.64 0 0 1-1.64-1.64v-6.563c0-.906.734-1.64 1.64-1.64Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "saved_agents_svg__c",
    x1: 138.5,
    x2: 21.5,
    y1: 85.5,
    y2: 85.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78AFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#598CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5183BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "saved_agents_svg__e",
    x1: 19.5,
    x2: 47,
    y1: 21.5,
    y2: 50.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "saved_agents_svg__g",
    x1: 123,
    x2: 139.5,
    y1: 120,
    y2: 153.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7E4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D3B5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "saved_agents_svg__b",
    width: 133,
    height: 133,
    x: 13.5,
    y: 21,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10156_39637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10156_39637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "saved_agents_svg__d",
    width: 63.352,
    height: 63.352,
    x: 1.324,
    y: 5.824,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10156_39637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10156_39637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "saved_agents_svg__f",
    width: 43.815,
    height: 43.815,
    x: 110.796,
    y: 116.796,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.204,
    dy: 2.204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.204
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10156_39637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10156_39637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "saved_agents_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h160v160H.5z"
  })))));
};
export default SvgSavedAgents;